import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWorkPosition } from "src/models/HumanResources/WorkPositions.models";

interface WorkPositionState {
  workPositions: IWorkPosition[];
  workPositionToEdit: IWorkPosition | null;
}

const initialState: WorkPositionState = {
  workPositions: [],
  workPositionToEdit: null,
};

const WorkPositionSlice = createSlice({
  name: "WorkPosition",
  initialState,
  reducers: {
    setWorkPositionList: (state, action: PayloadAction<IWorkPosition[]>) => {
      state.workPositions = action.payload;
    },
    concatListWorkPosition: (
      state: WorkPositionState,
      action: PayloadAction<IWorkPosition[]>
    ) => {
      state.workPositions = [...state.workPositions.concat(action.payload)];
    },
    setWorkPositionToEdit: (
      state,
      action: PayloadAction<IWorkPosition | null>
    ) => {
      state.workPositionToEdit = action.payload;
    },
    addWorkPosition: (state, action: PayloadAction<IWorkPosition>) => {
      state.workPositions.push(action.payload);
    },
    updateWorkPosition: (state, action: PayloadAction<IWorkPosition>) => {
      let itemIndex = state.workPositions.findIndex(
        item => item.workPositionId === action.payload.workPositionId
      );
      if (itemIndex !== -1) state.workPositions[itemIndex] = action.payload;
    },
    deleteWorkPosition: (state, action: PayloadAction<number>) => {
      const newArray = state.workPositions.filter(
        item => item.workPositionId !== action.payload
      );
      state.workPositions = newArray;
    },
  },
});

export const {
  setWorkPositionList,
  concatListWorkPosition,
  setWorkPositionToEdit,
  addWorkPosition,
  updateWorkPosition,
  deleteWorkPosition,
} = WorkPositionSlice.actions;

export default WorkPositionSlice.reducer;
